// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1kyQE","upload":"Small_upload__nxvhn","imageWrap":"Small_imageWrap__3nHz7","removeBtn":"Small_removeBtn__34nF8"};